import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { I18nService } from '@core/i18n/i18n.service';
import { CentralConfigService } from '@core/services/central-config.service';
import { GlobalFilterStoredService } from '@core/services/global-filter-stored.service';
import { SessionService } from '@core/session.service';
import { Observable } from 'rxjs';

export const SKIP_INNOVATION_SPACE = 'X-Skip-InnovationSpace';

@Injectable({
  providedIn: 'root',
})
export class ApiHeadersInterceptor implements HttpInterceptor {
  constructor(
    private readonly sessionService: SessionService,
    private readonly i18nService: I18nService,
    private readonly centralConfig: CentralConfigService,
    private readonly globalFilterStored: GlobalFilterStoredService
  ) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    if (this.shouldExcludeRequest(request)) {
      return next.handle(request);
    }

    const skipInnovationSpace = request.headers.has(SKIP_INNOVATION_SPACE);

    if (skipInnovationSpace) {
      request = request.clone({
        headers: request.headers.delete(SKIP_INNOVATION_SPACE),
      });
    }

    if (!request.headers.get('Content-Type')) {
      request.headers.set('Content-Type', 'application/json');
    }

    const currentTimeZoneOffset = new Date().getTimezoneOffset() / -60;
    const currentTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const defaultLocale = this.i18nService.language?.locale;
    const locale = request.headers.get('jip-locale') || defaultLocale;

    const orgFromFilter = (
      this.globalFilterStored.getCurrentFilterTokenSnapshot() ?? ''
    ).toString();

    const organizationId =
      this.centralConfig.innovationSpaceId?.toString() ?? orgFromFilter ?? '';

    const headers: Record<string, string> = {
      'jip-locale': locale,
      'Tenant-Id': this.sessionService.getTenantId() || '',
      'Time-Zone-Offset': currentTimeZoneOffset.toString(),
      'Time-Zone': currentTimeZone,
      NewsRedirectPath: this.centralConfig.newsRedirectPath || '',
    };

    if (!skipInnovationSpace) {
      headers['InnovationSpace'] = organizationId;
    }

    request = request.clone({ setHeaders: headers });

    return next.handle(request);
  }

  private shouldExcludeRequest(request: HttpRequest<unknown>): boolean {
    return (
      /(tenants\/domain)/i.test(request.url) &&
      /(wp-json\/wp\/v2\/media)/i.test(request.url)
    );
  }
}
